<template>
  <div
    v-bind:class="{
      'layout-footer gran-cliente': granCliente,
      'layout-footer': !granCliente,
    }"
  >
    <div class="contentContainer">
      <div class="copyright">
        <span class="footer-text" style="margin-right: 5px">{{
          $t("footer.copyright")
        }}</span>
      </div>
      <div class="externalLinks">
        <ul>
          <li
            v-for="item in menuItems"
            :key="item.name"
            @click="navigate(item.route)"
          >
            <span>{{ item.name }}</span>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "AppFooter",
  props: ["granCliente"],
  data: () => ({
    menuItems: [
      {
        name: "Condiciones generales",
        route: process.env.VUE_APP_ICIRED_BASE_URL + "/condiciones-generales",
      },
      {
        name: "Política de privacidad",
        route: process.env.VUE_APP_ICIRED_BASE_URL + "/politica-de-privacidad",
      },
      {
        name: "Política de cookies",
        route: process.env.VUE_APP_ICIRED_BASE_URL + "/politica-de-cookies",
      },
      {
        name: "Derechos ARSOLP",
        route: process.env.VUE_APP_ICIRED_BASE_URL + "/politica-de-privacidad",
      },
    ],
  }),
  methods: {
    navigate(route) {
      window.open(route);
    },
  },
};
</script>

<style lang="scss" scoped>
</style>